import React from "react";

const Java_User_Input = () => {
  return (
    <div>
      <h1>Java User Input()</h1>
      <p>This page provides explanations, examples, and common use-cases for Java User Input() in Java.</p>
    </div>
  );
};

export default Java_User_Input;
